import { useSelector } from 'react-redux';
import { useUsersCRUDActions } from '@mm/state/actions/UsersCRUDActions';
import { OneTimeConfirmationModalType } from '@mm/state/model/CompanyUsersModel';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { selectCurrentUserId } from '@mm/state/selectors/userSelector';
import { selectActiveCompanyId } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import { GeneralConfirmModalProps } from '@mm/state/modules/modalsState/props';

export const useOneTimeConfirmationModal = (
  modalType: OneTimeConfirmationModalType,
  modalProps: Omit<GeneralConfirmModalProps, 'onCloseHandler'>,
) => {
  const modalsSeen =
    useSelector(
      (state: StoreState) =>
        state.session.session.userAttributes.oneTimeConfirmationModalsSeen,
    ) || {};
  const companyId = useSelector(selectActiveCompanyId);
  const currentUserId = useSelector(selectCurrentUserId);

  const { openGeneralConfirmModal } = useModalActions();
  const { updateUserAttributes } = useUsersCRUDActions();

  return (props: { onConfirm: () => void; onCancel?: () => void }) => {
    const { onConfirm, onCancel } = props;
    if (modalsSeen[modalType]) {
      return onConfirm();
    }

    const onCloseHandler = async (ok: boolean) => {
      if (!ok) {
        return onCancel?.();
      }

      await updateUserAttributes(companyId, currentUserId, {
        oneTimeConfirmationModalsSeen: { ...modalsSeen, [modalType]: true },
      });
      onConfirm();
    };
    openGeneralConfirmModal({ ...modalProps, onCloseHandler });
  };
};
